export const CONSTANTS = {
    algodToken : '',
    baseServer : 'https://testnet-api.algonode.cloud',
    port : '443',
    APP_ID : 252279791,
    explorer : 'https://testnet.algoexplorer.io/application/252279791' 
 }